import { CampagneDto, useGetCurrentCampagneQuery } from '@common/services';

export function useCurrentCampagne() {
  const { data: campagne } = useGetCurrentCampagneQuery();
  return { campagne: campagne as CampagneDto | undefined };
}